export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const ApiEndPoints = {
  AUTH: {
    register: `${API_BASE_URL}/api/v1/dealer/auth/register`,
    login: `${API_BASE_URL}/api/v1/admin/auth/login`,
    me: `${API_BASE_URL}/api/v1/admin/auth/me`,
    forgot: `${API_BASE_URL}/api/v1/admin/auth/forgot-password`,
    verifotp: `${API_BASE_URL}/api/v1/admin/auth/verify-otp`,
    resendotp: `${API_BASE_URL}/api/v1/admin/auth/resend-otp`,
    reset: `${API_BASE_URL}/api/v1/admin/auth/reset-password`,
    changePassword: `${API_BASE_URL}/api/v1/admin/auth/change-password`,
    logout: `${API_BASE_URL}/api/v1/dealer/auth/logout`,
  },
  PROFILE: {
    edit: `${API_BASE_URL}/api/v1/dealer/auth`,
  },
  DASHBOARD: {
    count: `${API_BASE_URL}/api/v1/admin/dashboard/card`,
    recentActivity: `${API_BASE_URL}/api/v1/dealer/recent-activities`
  },
  GET_REGION: {
    country: `https://api.countrystatecity.in/v1/countries`,
    state: `https://api.countrystatecity.in/v1/countries/`,
    city: `https://api.countrystatecity.in/v1/countries/`
  },
  PRIVACY_POLICY: {
    get: type => `${API_BASE_URL}/api/v1/admin/legal-content/${type}`,
    updatePrivacy: type => `${API_BASE_URL}/api/v1/admin/legal-content/${type}`
  },
  TERMS_CONDITIONS: {
    get: type => `${API_BASE_URL}/api/v1/admin/legal-content/${type}`,
    updateTerms: type => `${API_BASE_URL}/api/v1/admin/legal-content/${type}`
  },
  HELP_SUPPORT: {
    list: `${API_BASE_URL}/api/v1/misc/dealer/faq`,
  },
  NOTIFICATION: {
    list: `${API_BASE_URL}/api/v1/dealer/notifications`,
    markAllAsRead: `${API_BASE_URL}/api/v1/dealer/notifications/mark-as-read-all`,
    markAsRead: (id) => `${API_BASE_URL}/api/v1/dealer/notifications/${id}/read`,
  },
  USERS: {
    list: `${API_BASE_URL}/api/v1/admin/manage-user`,
    create: `${API_BASE_URL}/api/v1/admin/manage-user`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/manage-user/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/manage-user/${id}`,
    statusUpdate: (id) => `${API_BASE_URL}/api/v1/admin/manage-user/status/${id}`,
    detail: (id) => `${API_BASE_URL}/api/v1/admin/manage-user/${id}`
  },
  ROLES: {
    list: `${API_BASE_URL}/api/v1/admin/role`,
    create: `${API_BASE_URL}/api/v1/admin/role`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/role/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/role/${id}`,
  },
  PERMISSIONS: {
    list: `${API_BASE_URL}/api/v1/admin/permissions`,
    create: `${API_BASE_URL}/api/v1/admin/permissions`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/permissions/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/permissions/${id}`,
  },
  SUB_ADMIN: {
    list: `${API_BASE_URL}/api/v1/admin/sub-admin`,
    create: `${API_BASE_URL}/api/v1/admin/sub-admin`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/sub-admin/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/sub-admin/${id}`,
    updateStatus: (id) => `${API_BASE_URL}/api/v1/admin/sub-admin/update-status/${id}`,
  },
  CATEGORIES: {
    list: `${API_BASE_URL}/api/v1/admin/category`,
    create: `${API_BASE_URL}/api/v1/admin/category`,
    update: (categoryId) => `${API_BASE_URL}/api/v1/admin/category/${categoryId}`,
    updateStatus: (categoryId) => `${API_BASE_URL}/api/v1/admin/category/status/${categoryId}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/category/${id}`,
  },
  REGIONS: {
    list: `${API_BASE_URL}/api/v1/admin/region`,
    create: `${API_BASE_URL}/api/v1/admin/region`,
    update: (regionId) => `${API_BASE_URL}/api/v1/admin/region/${regionId}`,
    updateStatus: (regionId) => `${API_BASE_URL}/api/v1/admin/region/status/${regionId}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/region/${id}`,
  },
  COURSES: {
    list: `${API_BASE_URL}/api/v1/admin/course/list`,
    create: `${API_BASE_URL}/api/v1/admin/course`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/course/${id}`,
    updateStatus: (id) => `${API_BASE_URL}/api/v1/admin/course/status/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/course/${id}`,
  },
  MODULES: {
    list: (courseId) => `${API_BASE_URL}/api/v1/admin/lesson-module/list/${courseId}`,
    create: `${API_BASE_URL}/api/v1/admin/lesson-module`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/lesson-module/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/lesson-module/${id}`,
  },
  LESSONS: {
    list: (moduleId) => `${API_BASE_URL}/api/v1/admin/lesson/module-wise/${moduleId}`,
    create: `${API_BASE_URL}/api/v1/admin/lesson`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/lesson/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/lesson/${id}`,
  },
  CULTURAL: {
    list: `${API_BASE_URL}/api/v1/admin/cultural-module/list`,
    listById: (moduleId) => `${API_BASE_URL}/api/v1/admin/cultural-module/${moduleId}`,
    create: `${API_BASE_URL}/api/v1/admin/cultural-module`,
    update: (moduleId) => `${API_BASE_URL}/api/v1/admin/cultural-module/${moduleId}`,
    delete: (moduleId) => `${API_BASE_URL}/api/v1/admin/cultural-module/${moduleId}`,
    updateStatus: (moduleId) => `${API_BASE_URL}/api/v1/admin/cultural-module/status/${moduleId}`,
  }
}
